/* Nzaam Image-to-Variant Sync v3
 * Swatch click => main gallery image direct replace + sticky ATC image sync
 */
document.addEventListener('DOMContentLoaded', function () {

  var swatches   = document.querySelectorAll('.nzv__swatch');
  if (!swatches.length) return;

  var labelEl    = document.getElementById('NzSelectedLabel');
  var atcThumb   = document.getElementById('NzAtcThumb');

  /* ── find main gallery image (first visible <img> in the media list) ── */
  function getMainImg() {
    return (
      document.querySelector('.product__media-list .product__media-item.is-active img') ||
      document.querySelector('.product__media-list .product__media-item img') ||
      document.querySelector('.product__media-item img')
    );
  }

  /* ── replace main gallery image with fade ── */
  function setMainImage(src) {
    var img = getMainImg();
    if (!img || !src) return;
    img.style.transition = 'opacity 0.15s ease';
    img.style.opacity    = '0';
    var newImg   = new Image();
    newImg.onload = function () {
      img.src     = newImg.src;
      img.srcset  = '';
      img.style.opacity = '1';
    };
    newImg.onerror = function () {
      img.style.opacity = '1';
    };
    newImg.src = src;
  }

  /* ── sync native Shopify variant picker ── */
  function syncNative(variantId) {
    var radio = document.querySelector('.nz-native-variants input[value="' + variantId + '"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var idInput = document.querySelector('product-form input[name="id"], form[action*="cart"] input[name="id"]');
    if (idInput && idInput.value !== String(variantId)) {
      idInput.value = variantId;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* ── swatch click handler ── */
  swatches.forEach(function (sw) {

    sw.addEventListener('click', function () {
      /* 1. active state */
      swatches.forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');

      /* 2. update label */
      if (labelEl) labelEl.textContent = sw.dataset.variantTitle || '';

      /* 3. replace main gallery image directly */
      var imgSrc = sw.dataset.imgSrc || '';
      if (imgSrc) setMainImage(imgSrc);

      /* 4. update sticky ATC thumb */
      if (atcThumb && imgSrc) {
        atcThumb.style.opacity = '0';
        var t = new Image();
        t.onload = function () {
          atcThumb.src = t.src;
          atcThumb.style.transition = 'opacity 0.15s';
          atcThumb.style.opacity = '1';
        };
        t.src = sw.dataset.imgSrc.replace('width=1200', 'width=160');
      }

      /* 5. sync native picker for cart/price updates */
      syncNative(sw.dataset.variantId);
    });

    sw.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') sw.click();
    });
  });

});
